<template>
    <generic-block-options :block="block"
                           :hide-text-color="true"
                           :save-url="saveUrl"
                           :has-tab-titles="hasTabTitles"
    />
</template>

<script>
    import GenericBlockOptions from './GenericBlockOptions';

    export default {
        name: 'Column',
        components: {
            GenericBlockOptions,
        },
        props: {
            block: {
                type: Object,
                required: true,
            },
            saveUrl: {
                type: String,
                required: true,
            },
            hasTabTitles: {
                type: Boolean,
                default: () => true,
            }
        },
    };
</script>